"use client";

import React from "react";
import GenericSubstantiveProcedures from "../substantive-procedures/GenericSubstantiveProcedures";

interface DepreciationSubstantiveProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
}

const WORKSPACE_NAME = "Depreciation";

export default function DepreciationSubstantive({ onBack, setActiveSection }: DepreciationSubstantiveProps) {
  return (
    <GenericSubstantiveProcedures
      workspaceName={WORKSPACE_NAME}
      area="Execution"
      onBack={onBack}
      setActiveSection={setActiveSection}
    />
  );
}
